import { z } from "@/zod";
import { address } from "./address";
import { coordinates } from "@/schemas/coordinates";
import { storeStatus } from "@/schemas/storeStatus";
import { applyEmptyStringsToNulls } from "@/lib/utils/zod";
import { postalCode, streetNumber } from "./commonFields";

export const store = z.object({
  id: z.string().length(26),
  ref_number: z.number().nonnegative().nullish(),
  name: z.string().min(1),
  network: z.string().min(1),
  network_id: z.string().min(1),
  store_format: z.string().min(1),
  store_format_id: z.string().min(1).nullish(),
  store_number: z.string().max(100).nullish(),
  store_number2: z.string().max(100).nullish(),
  client_store_number: z.string().max(100).nullish(),
  shopping_center: z.string().max(100).nullish(),
  notes: z.string().max(1000).nullish(),
  status: storeStatus,
  ...address.omit({
    contact_person: true,
    email: true,
    phone_number: true,
  }).shape,
  ...coordinates.shape,
  // <exception>
  // This is not 'nullish' by accident - just a business logic quirk, rest of the address fields stays as is
  postal_code: postalCode.nullish(),
  street_number: streetNumber.nullish(),
  province_id: z.string().nullish(),
  // </exception>
});

export const readStore = store.readonly();
export const writeStore = applyEmptyStringsToNulls(
  store
    .omit({
      id: true,
      network: true,
      store_format: true,
      province: true,
      province_id: true,
      ref_number: true,
      client_store_number: true,
      name: true,
    })
    .extend({
      province_id: z.string().nullish(),
    }).shape,
);
